module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="block">\n  <legend>Payment Items</legend>\n  <div id="table-hook"></div>\n  <div id="page-hook"></div>\n</fieldset>\n\n<div class="actions">\n  <button type="button" class="button map">Map Payment Items</button>\n  <button type="button" class="button button-secondary show-hidden">\n    Toggle Hidden\n  </button>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/paymentitem/index.html
// module id = 242
// module chunks = 0